import { DevelopmentalData } from "@/types/developmental";

export const age5Activities: DevelopmentalData = {
  motor: [
    "Bike riding",
    "Sports activities",
    "Writing practice",
    "Art projects",
    "Dance classes"
  ],
  language: [
    "Reading exercises",
    "Writing activities",
    "Vocabulary games",
    "Story creation",
    "Discussion groups"
  ],
  cognitive: [
    "Math games",
    "Science projects",
    "Pattern recognition",
    "Problem-solving challenges",
    "Memory exercises"
  ],
  independent: [
    "Daily routine planning",
    "Simple cooking tasks",
    "Personal organization",
    "Time management activities",
    "Decision-making exercises"
  ],
  social: [
    "Team sports",
    "Group projects",
    "Leadership activities",
    "Conflict resolution practice",
    "Friendship building games"
  ]
};